import { render, staticRenderFns } from "./ProductDetailBuyList.vue?vue&type=template&id=092d05e6&scoped=true"
import script from "./ProductDetailBuyList.vue?vue&type=script&lang=js"
export * from "./ProductDetailBuyList.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailBuyList.vue?vue&type=style&index=0&id=092d05e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d05e6",
  null
  
)

export default component.exports